import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import Header from "components/common/Header/Header";
import SelectOption from "components/common/Select/Select";
import SideBarNew from "components/common/SideBar/SideBarNew";
import {
  REPORTING_BREADCRUMB,
  REPORTING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import { LoginContext } from "helpers/LoginContext";
import React, { useContext, useEffect, useState } from "react";
import PaginationComponent from "components/common/Pagination/index";
import {
  DOC_DOWNLOAD_URL,
  DOCUMENTS_TYPE,
  emptyPaginationObj,
  portalTypeOptions,
  REPORTING_LIMIT,
  SORT_TYPE,
  StatusOptions,
  StatusOptionsReporting,
} from "Constants/constant";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import TableHeader from "components/common/Table/TableHeader";
import { apiPostRequest } from "helpers/Requests";
import { URL_REPORTING_WORKER_EXPIRING_DOCUMENT_REPORTS } from "store/services/URL";

import moment from "moment";

import { toast } from "react-toastify";
import {
  addMonths,
  exportTOExcel,
  formatDateIntoDMYToDisplay,
  formatDateReporting,
  truncateTextReporting,
} from "Utils/utils";
import useReportExport from "../useReportExport";
import {
  ReportFilterActions,
  ReportFilterField,
  ReportFilterGrid,
  ReportFilterSearchField,
  ReportFiltersShell,
  ReportPageContent,
  ReportTableSection,
} from "../reportFilterUi";
import { withReportSortOnUrl } from "../reportExportUtils";
import api from "store/services/auth.services";
import PopoverContainer from "components/common/Popover/PopoverContainer";

const WorkerExpiringDocuments = ({
  getTeamManagmentListCall,
  teamManagementList,
  getParticipantList,
  spParticipants,
}) => {
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const [selectedWorker, setSelectedWorker] = useState(null);

  useEffect(() => {
    const filters = {
      page: 1,
      per_page: 500,
      search: null,
    };
    getParticipantList({ filters, bodyFilter: null });
    getTeamManagmentListCall({ filters, bodyFilter: null });
  }, []);

  const [workerList, setWorkerList] = useState([
    { label: "All", value: "all" },
  ]);
  const [participantList, setParticipant] = useState([
    { label: "All", value: "all" },
  ]);

  const [status, setStatus] = useState(null);
  const [BirthDate, setBirthDate] = useState(null);

  const [search, setSearch] = useState(null);

  const [reportList, setReports] = useState(null);
  const [loader, setLoader] = useState(false);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [page, setPage] = useState(1);
  const [sortDescending, setSortDescending] = useState(
    paginationObj.sort_order === SORT_TYPE.DESC ? true : false
  );
  const [sortBy, setSortBy] = useState(paginationObj.sort_field);
  const [role, setRole] = useState(null);
  const [roleList, setRoleList] = useState([]);
  // Default to Required Document — matches the dashboard "Expiring Docs" widget,
  // which lists worker compliance (required) documents.
  const [selectedDocumentType, setSelectedDocType] = useState(
    DOCUMENTS_TYPE.find((type) => type.value === "required") ||
      DOCUMENTS_TYPE[0]
  );
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [isDisableSearch, setIsDisableSearch] = useState(false);
  useEffect(() => {
    const updateLists = async () => {
      const workers =
        teamManagementList?.employees?.data?.map((item) => ({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.id,
        })) || [];

      const sortedWorkers = workers.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      setWorkerList([{ label: "All", value: "all" }, ...sortedWorkers]);
    };

    updateLists();
  }, [teamManagementList, spParticipants]);

  useEffect(() => {
    api
      .roleAndPermissionList({
        type: portalTypeOptions[1].value,
      })
      .then((res) => {
        const rolesList = res.data;

        const Roles =
          rolesList &&
          rolesList?.length > 0 &&
          rolesList?.map((role) => ({
            label: `${role?.name}`,
            value: `${role?.name}`,
          }));
        // setRoleList((prevRoleList) => [...prevRoleList, ...Roles]);
        setRoleList([{ label: "All", value: "all" }, ...Roles]);
      })
      .catch((error) => {
        console.error("API request failed:", error);
      });
  }, []);

  const [isInitialRender, setIsInitialRender] = useState(true);
  const { runExport, QueuedModal, getExportSortFilters } = useReportExport(
    "worker_documents_report",
    "Worker Expiring Documents",
    { sortBy, sortDescending }
  );

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      return;
    }

    fetchListReports();
  }, [page]);

  const fetchListReports = async (
    isClearAll = false,
    report = null,
    filters = null
  ) => {
    if (!fromDate && !toDate) {
      toast("Select create date range to get data");
      return;
    }

    setLoader(true);
    let url = `${URL_REPORTING_WORKER_EXPIRING_DOCUMENT_REPORTS}?per_page=25&page=${page}`;
    url = withReportSortOnUrl(url, filters || {}, sortBy, sortDescending);
    const payload = {
      search: search ? search : "",

      worker: isClearAll
        ? "all"
        : selectedWorker
        ? selectedWorker?.value
        : "all",
      status: isClearAll ? "all" : status ? status.value : "all",
      document_type: isClearAll
        ? "all"
        : selectedDocumentType
        ? selectedDocumentType?.value
        : "all",

      role: isClearAll ? "all" : role ? role?.value : "all",
      expire_date: isClearAll
        ? "all"
        : toDate && fromDate
        ? [fromDate, toDate]
        : "all",
    };
    if (report) {
      await runExport({
        format: report,
        payload,
        syncUrl: url,
        filters: filters || {},
        totalRows: paginationObj?.total,
        setLoader,
        onSyncExcel: exportTOExcelFile,
        onSyncPdf: (downloadUrl) => window.open(downloadUrl, "_blank"),
      });
      return;
    }
    await apiPostRequest(url, payload)
      .then((res) => {
        if (res.status === 200) {
          setLoader(false);
          setReports(res?.data?.data);
          setPaginationObj((prev) => ({
            ...prev,
            total: res?.data?.data?.documents?.total,
            totalPages: Math.ceil(
              res?.data?.data?.documents?.total /
                res?.data?.data?.documents?.per_page
            ),
          }));
        }
      })
      .catch((error) => {
        toast.error(`${error}`);
        console.log({ error });
        setLoader(false);
      });
  };
  const handleFileDownLoad = (e) => {
    fetchListReports(false, e, getExportSortFilters());

    // if (e === "xlsx") {
    //   exportTOExcelFile();
    // } else {
    //   fetchListReports(false, e);
    // }
  };

  const handleSearch = () => fetchListReports(false);

  const handleClearFilters = () => {
    setBirthDate(null);
    setStatus(null);
    setSelectedWorker(null);
    setSelectedFromDate(null);
    setRole(null);
    setSearch(null);
    setReports([]);
    setFromDate(null);
    setToDate(null);
  };

  const exportTOExcelFile = (reportData) => {
    let transformedData = null;
    if (reportData && reportData?.documents) {
      let preparedData = reportData?.documents;
      transformedData =
        preparedData &&
        preparedData?.length > 0 &&
        preparedData?.map((item) => {
          return {
            Support_Worker: `${item.worker.first_name} ${item.worker.last_name}`,
            Document: item.name,
            Expiry_Date:
              item.expire_date && moment(item.expire_date).format("DD/MM/YYYY"),
            Document_Status:
              item.document_status || (item.is_expire ? "Expired" : "Valid"),
            Contact_Number: item.worker.phone,
            Email: item.worker.email,
            Worker_Status: item.worker.status ? "Active" : "InActive",
            Role: item?.worker.role,
            Employee_Type: item.worker.employee_type,
            Employee_Level: item.worker.salary_slab,
            Employee_Joining_Date:
              item.worker.joining_date &&
              moment(item.worker.joining_date).format("DD/MM/YYYY"),
          };
        });
    }
    if (
      !transformedData ||
      transformedData === undefined ||
      transformedData?.length === 0
    ) {
      toast("No data found!");
      return;
    }

    exportTOExcel(transformedData);
  };

  const handleFetch = (obj) => {
    fetchListReports(false, null, { ...obj });
  };

  const flipSort = (by) => {
    setSortBy(by);
    setSortDescending(!sortDescending);
    handleFetch({
      sort_field: by,
      sort_order: !sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };

  return (
    <div className='min-h-full '>
      <SideBarNew />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col `}
      >
        <main className='flex-1 bg-gray-50 min-h-screen'>
          <Header
            title='Worker Expiring Document Reports'
            breadcrumb={
              <Breadcrumb
                pages={REPORTING_BREADCRUMB(
                  REPORTING_BREADCRUMB_PAGES.WORKER_EXPIRING_DOCUMENTS_REPORTS
                )}
              />
            }
          />
          <ReportPageContent>
            <ReportFiltersShell>
              <ReportFilterGrid columns={4}>
                <ReportFilterField label='Support Worker'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='worker_id'
                    isSearch={true}
                    data={workerList || []}
                    selectedOption={selectedWorker}
                    handleChange={(e) => setSelectedWorker(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Document Type'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='document_type'
                    isSearch={true}
                    data={DOCUMENTS_TYPE || []}
                    selectedOption={selectedDocumentType}
                    handleChange={(e) => {
                      setSelectedDocType(e);
                      setReports([]);
                    }}
                  />
                </ReportFilterField>
                <ReportFilterField label='Role'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='pt_id'
                    isSearch={true}
                    data={roleList || []}
                    selectedOption={role}
                    handleChange={(e) => setRole(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Worker Status'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='status'
                    isSearch={true}
                    data={StatusOptionsReporting || []}
                    handleChange={(e) => setStatus(e)}
                    selectedOption={status}
                  />
                </ReportFilterField>
                <ReportFilterField label='Select Expiry Date Range(Max 6 months)' required>
                  <DateRangePickerNew
                    handleCancel={() => {
                      setFromDate(null);
                      setToDate(null);
                    }}
                    handleChange={(obj) => {
                      if (obj) {
                        obj.fromDate && setFromDate(obj.fromDate);
                        obj.toDate && setToDate(obj.toDate);
                      }
                    }}
                    setSelectedFromDate={setSelectedFromDate}
                    fromDate={fromDate}
                    toDate={toDate}
                    maxDate={addMonths(selectedFromDate, 6)}
                    setIsDisableSearch={setIsDisableSearch}
                  />
                </ReportFilterField>
                <ReportFilterSearchField
                  label='Search by document name'
                  search={search}
                  setSearch={setSearch}
                  onSearch={handleSearch}
                  placeholder='Search by document name'
                />
              </ReportFilterGrid>
              <ReportFilterActions
                onSearch={handleSearch}
                onClear={handleClearFilters}
                onExport={handleFileDownLoad}
                isLoading={loader}
                isSearchDisabled={isDisableSearch}
                isUserGracePeriodOver={isUserGracePeriodOver}
              />
            </ReportFiltersShell>
            <ReportTableSection>
                <table className='border min-w-full divide-y divide-gray-300'>
                  <thead
                    // style={{ top: "130px" }}
                    className='bg-gray-50 sticky z-[5]'
                  >
                    <tr>
                      <TableHeader isSort={false} label={"Support Worker"} cssClass='bg-blue-50 pl-4' />

                      <TableHeader
                        sortName={
                          selectedDocumentType.value === "general"
                            ? "link"
                            : "name"
                        }
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Document"}
                        cssClass='bg-blue-50 pl-4'
                      />

                      <TableHeader
                        sortName={
                          selectedDocumentType.value === "general"
                            ? "expiry_time"
                            : "expire_date"
                        }
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Expiry Date"}
                        cssClass='bg-blue-50 pl-4'
                      />

                      <TableHeader isSort={false} label={"Document Status"} cssClass='bg-blue-50 pl-4' />

                      <TableHeader isSort={false} label={"Contact Number"} cssClass='bg-blue-50 pl-4' />

                      <TableHeader isSort={false} label={"Email"} cssClass='bg-blue-50 pl-4' />

                      <TableHeader isSort={false} label={"Worker Status"} cssClass='bg-blue-50 pl-4' />

                      <TableHeader isSort={false} label={"Role"} cssClass='bg-blue-50 pl-4'/>

                      <TableHeader isSort={false} label={"Emp_Type"} cssClass='bg-blue-50 pl-4' />

                      <TableHeader isSort={false} label={"Level"} cssClass='bg-blue-50 pl-4' />
                      <TableHeader isSort={false} label={"Joining Date"} cssClass='bg-blue-50 pl-4' />
                    </tr>
                  </thead>
                  <tbody className='divide-y divide-gray-200 bg-white overflow-y-auto'>
                    {loader ? (
                      <tr className='bg-white'>
                        <td colSpan={11} className='py-6 text-center bg-white'>
                          <div
                            className={`flex flex-col w-full min-h-screen items-center justify-start`}
                          >
                            <CircularLoader
                              classes='flex justify-center items-center'
                              classloader='loader-l'
                            />
                          </div>
                        </td>
                      </tr>
                    ) : reportList !== null &&
                      reportList?.documents?.data?.length > 0 ? (
                      reportList?.documents?.data?.map((document, index) => (
                        <tr
                          key={index}
                          className='even:bg-white odd:bg-gray-50'
                        >
                          <td className='whitespace-nowrap py-4 text-sm'>
                            <div className='flex items-center'>
                              <div className='capitalize'>
                                <span
                                  title={`${document.worker.first_name} ${document.worker.last_name}`}
                                >
                                  <p
                                    className={`w-40 truncate cursor-pointer pl-1`}
                                  >{`${document.worker.first_name} ${document.worker.last_name}`}</p>
                                </span>
                              </div>
                            </div>
                          </td>

                          <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                            {/* <div
                                className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                                style={{
                                  maxWidth: "100px",
                                  textOverflow: "ellipsis",
                                }}
                                title={document?.name}
                              >
                            {document?.name || "-"}
                            </div> */}

                            <div
                              className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                              style={{
                                maxWidth: "100px",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {document?.name ? (
                                <PopoverContainer
                                  cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                  itemComponent={() => {}}
                                  toolTip={`${document?.name}`}
                                >
                                  <span>
                                    {truncateTextReporting(document?.name)}
                                  </span>
                                </PopoverContainer>
                              ) : (
                                "-"
                              )}
                            </div>
                          </td>
                          <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                            {document?.expire_date
                              ? moment(document.expire_date).format(
                                  "DD/MM/YYYY"
                                )
                              : "-"}
                          </td>
                          <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                            <span
                              className={`${
                                document?.is_expire
                                  ? "bg-red-100 text-red-700"
                                  : "bg-green-100 text-green-700"
                              } inline-flex rounded-full px-2 text-xs font-semibold leading-5`}
                            >
                              {document?.document_status ||
                                (document?.is_expire ? "Expired" : "Valid")}
                            </span>
                          </td>
                          <td className='w-40 truncate py-4  px-3 text-sm'>
                            {document?.worker?.phone || "-"}
                          </td>
                          <td className='w-40 truncate py-4  px-3 text-sm'>
                            {document?.worker?.email || "-"}
                          </td>

                          <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                            <span
                              className={`${
                                document?.worker?.status
                                  ? "bg-green-100 text-green-700"
                                  : "bg-red-100 text-red-700"
                              } inline-flex rounded-full  px-2 text-xs font-semibold leading-5 capitalize `}
                            >
                              {document?.worker?.status ? "Active" : "InActive"}
                            </span>
                          </td>
                          <td className='w-40 truncate py-4  px-3 text-sm'>
                            {document?.worker?.role || "-"}
                          </td>
                          <td className='px-2 py-[11px] text-sm text-gray-500'>
                            {document?.worker.employee_type || "-"}
                          </td>

                          <td className='w-40 truncate py-4  px-3 text-sm'>
                            {document?.worker?.salary_slab || "-"}
                          </td>

                          <td className='w-40 truncate py-4  px-3 text-sm'>
                            {document?.worker?.joining_date
                              ? formatDateIntoDMYToDisplay(
                                  document.worker.joining_date
                                )
                              : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={11}
                          className='py-6 text-center text-red-600'
                        >
                          No data found. Please adjust your filters to get
                          relevant results
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
            </ReportTableSection>
              {reportList && reportList?.documents?.data?.length > 0 && (
                <div className='mt-3'>
                  <PaginationComponent
                    page={paginationObj?.page || 1}
                    activeListLength={reportList?.documents?.data || []}
                    limit={REPORTING_LIMIT}
                    totalList={paginationObj?.total}
                    handlePagination={(e) => {
                      setPage(e);
                      const obj = paginationObj;
                      obj.page = e;
                      setPaginationObj({ ...obj });
                    }}
                    totalPages={paginationObj?.totalPages}
                  />
                </div>
              )}
          </ReportPageContent>
        </main>
      </div>
      <QueuedModal />
    </div>
  );
};

export default WorkerExpiringDocuments;
